import { useEffect, useRef, useState } from 'react';
import maplibregl, { NavigationControl } from 'maplibre-gl';
import { useMapSupportCheck } from '@ui-framework/index';

function JobMap({
  lat = 0,
  lng = 0,
  zoom = 14,
  maxBounds,
  onReady = () => {},
  ...props
}) {
  const { onError } = useMapSupportCheck();
  const mapContainer = useRef(null);
  const map = useRef(null);

  const [mapHeight, setMapHeight] = useState(() => window.innerHeight - 70);

  useEffect(() => {
    const updateHeight = () => {
      setMapHeight(window.innerHeight - 70);
    };
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  useEffect(() => {
    if (map.current) return; // stops map from intializing more than once
    const mapUrl = `https://api.maptiler.com/maps/${
      process.env.REACT_APP_MAP_ID || 'streets'
    }/style.json?key=${process.env.REACT_APP_MAP_API_KEY}`;

    map.current = new maplibregl.Map({
      container: mapContainer.current,
      style: mapUrl,
      center: [lng, lat],
      zoom,
      attributionControl: true,
      ...(maxBounds && { maxBounds }),
    });

    map.current.on('load', () => {
      onReady(map.current);
    });

    map.current.addControl(new NavigationControl(), 'bottom-right');

    map.current.on('error', e => {
      const message = e?.error?.message || '';

      if (
        message.includes('WebGL') ||
        message.includes('Exhausted') ||
        message.includes('context lost')
      ) {
        onError({
          checking: false,
          supported: false,
          error: message,
        });
      }
    });
  }, [lng, lat, zoom]);

  useEffect(() => {
    map.current?.resize();
  }, [mapHeight]);

  return (
    <div style={{ width: '100%', height: `${mapHeight}px` }} {...props}>
      <div ref={mapContainer} style={{ width: '100%', height: '100%' }} />
    </div>
  );
}

export default JobMap;
